import React from 'react';

const MultilineText = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.39583 6.1263C5.15433 6.1263 4.95833 5.9303 4.95833 5.6888V5.54297L2.625 5.54297V5.6888C2.625 5.9303 2.429 6.1263 2.1875 6.1263C1.946 6.1263 1.75 5.9303 1.75 5.6888L1.75 5.10547C1.75 4.86397 1.946 4.66797 2.1875 4.66797L5.39583 4.66797C5.63733 4.66797 5.83333 4.86397 5.83333 5.10547V5.6888C5.83333 5.9303 5.63733 6.1263 5.39583 6.1263Z"
      fill="var(--SECONDARY_DARK)"
    />
    <path
      d="M3.79199 8.7513C3.55049 8.7513 3.35449 8.5553 3.35449 8.3138L3.35449 5.10547C3.35449 4.86397 3.55049 4.66797 3.79199 4.66797C4.03349 4.66797 4.22949 4.86397 4.22949 5.10547L4.22949 8.3138C4.22949 8.5553 4.03349 8.7513 3.79199 8.7513Z"
      fill="var(--SECONDARY_DARK)"
    />
    <path
      d="M4.22949 8.75H3.35449C3.11299 8.75 2.91699 8.554 2.91699 8.3125C2.91699 8.071 3.11299 7.875 3.35449 7.875H4.22949C4.47099 7.875 4.66699 8.071 4.66699 8.3125C4.66699 8.554 4.47099 8.75 4.22949 8.75Z"
      fill="var(--SECONDARY_DARK)"
    />
    <path
      d="M9.47917 5.54297L7.4375 5.54297C7.196 5.54297 7 5.34697 7 5.10547C7 4.86397 7.196 4.66797 7.4375 4.66797L9.47917 4.66797C9.72067 4.66797 9.91667 4.86397 9.91667 5.10547C9.91667 5.34697 9.72067 5.54297 9.47917 5.54297Z"
      fill="var(--SECONDARY_DARK)"
    />
    <path
      d="M9.47917 7.14453L7.4375 7.14453C7.196 7.14453 7 6.94853 7 6.70703C7 6.46553 7.196 6.26953 7.4375 6.26953L9.47917 6.26953C9.72067 6.26953 9.91667 6.46553 9.91667 6.70703C9.91667 6.94853 9.72067 7.14453 9.47917 7.14453Z"
      fill="var(--SECONDARY_DARK)"
    />
    <path
      d="M9.47917 8.75H7.4375C7.196 8.75 7 8.554 7 8.3125C7 8.071 7.196 7.875 7.4375 7.875L9.47917 7.875C9.72067 7.875 9.91667 8.071 9.91667 8.3125C9.91667 8.554 9.72067 8.75 9.47917 8.75Z"
      fill="var(--SECONDARY_DARK)"
    />
    <path
      d="M9.47917 10.5L2.1875 10.5C1.946 10.5 1.75 10.304 1.75 10.0625C1.75 9.821 1.946 9.625 2.1875 9.625L9.47917 9.625C9.72067 9.625 9.91667 9.821 9.91667 10.0625C9.91667 10.304 9.72067 10.5 9.47917 10.5Z"
      fill="var(--SECONDARY_DARK)"
    />
    <path
      d="M9.47917 12.25L2.1875 12.25C1.946 12.25 1.75 12.054 1.75 11.8125C1.75 11.571 1.946 11.375 2.1875 11.375L9.47917 11.375C9.72067 11.375 9.91667 11.571 9.91667 11.8125C9.91667 12.054 9.72067 12.25 9.47917 12.25Z"
      fill="var(--SECONDARY_DARK)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.60417 14L10.0625 14C10.9474 14 11.6667 13.2807 11.6667 12.3958L11.6667 1.60417C11.6667 0.71925 10.9474 0 10.0625 0L1.60417 0C0.71925 0 0 0.71925 0 1.60417L0 12.3958C0 13.2807 0.71925 14 1.60417 14ZM0.875 1.60417C0.875 1.20225 1.20225 0.875 1.60417 0.875L10.0625 0.875C10.4644 0.875 10.7917 1.20225 10.7917 1.60417L10.7917 12.3958C10.7917 12.7977 10.4644 13.125 10.0625 13.125L1.60417 13.125C1.20225 13.125 0.875 12.7977 0.875 12.3958L0.875 1.60417Z"
      fill="var(--SECONDARY_DARK)"
    />
  </svg>
);

export default MultilineText;
